import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Implantologia'}>
      <Helmet title={"Implantologia - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
